/**
 * Feature Flags — Tier-Aware
 *
 * Features can be gated by user tier (free/paid).
 * Alpha testers (ALPHA_EMAILS) bypass all tier restrictions.
 */

import type { UserTier } from '@machina/core';
import { ALPHA_EMAILS } from '@machina/core';

interface FlagConfig {
  enabled: boolean;
  requiredTier: UserTier;
}

const FEATURE_FLAGS = {
  soloMode: { enabled: true, requiredTier: 'paid' as const },
  llmDeep:  { enabled: true, requiredTier: 'paid' as const },
} as const;

export type FeatureFlag = keyof typeof FEATURE_FLAGS;

/**
 * Check if a feature is enabled for the given user and tier.
 * Alpha users always get all features.
 */
export function isFeatureEnabled(flag: FeatureFlag, userEmail?: string | null, userTier: UserTier = 'free'): boolean {
  // Alpha testers see everything
  if (userEmail && ALPHA_EMAILS.includes(userEmail.toLowerCase())) {
    return true;
  }
  const config: FlagConfig = FEATURE_FLAGS[flag];
  if (!config.enabled) return false;
  if (config.requiredTier === 'paid' && userTier !== 'paid') return false;
  return true;
}
